/**
 * Friendly display labels for admin permission keys. Keyed by the raw permission
 * string returned by the API. Unknown/new keys fall back to a prettified version
 * of the key, so the list stays dynamic without shipping a code change.
 */
const PERMISSION_LABELS: Record<string, string> = {
  'patient.block': 'Block patients',
  'patient.changeemail': 'Update patient email',
  'patient.mediafile.delete': 'Delete patient media files',
  'admin.permissions.manage': 'Manage admin permissions',
}

/** Turns an unmapped key like `patient.some.action` into `Patient some action`. */
function prettifyKey(key: string): string {
  const words = key
    .split(/[.\-_]/)
    .filter(Boolean)
    .join(' ')
  if (!words) return key
  return words.charAt(0).toUpperCase() + words.slice(1)
}

/** Returns the friendly label for a permission, falling back to a prettified key. */
export function getPermissionLabel(key: string): string {
  return PERMISSION_LABELS[key] ?? prettifyKey(key)
}
